import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMini = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.882 8.044a.95.95 0 0 0-.307.126c-.071.051-1.366 1.253-2.878 2.671a464.438 464.438 0 0 1-2.878 2.688l-.129.109-1.27-1.189c-.698-.654-1.326-1.229-1.395-1.278a.994.994 0 0 0-.325-.127c-.611-.115-1.139.295-1.172.911-.026.459.001.491 1.752 2.129 1.798 1.682 1.818 1.696 2.42 1.696.638 0 .445.153 4.021-3.196 3.385-3.171 3.359-3.144 3.359-3.539-.001-.672-.545-1.127-1.198-1.001",
		fillRule: "evenodd",
		fill: "current"
	})
});
export default SvgCheckMini;
